import { CompositeDecorator } from 'draft-js';
import MultiDecorator from 'draft-js-plugins-editor/lib/Editor/MultiDecorator';

import getDecorators from './getDecorators';

const createMultipleDecorator = disabledDecorators => {
    const decorators = getDecorators(disabledDecorators);

    return new MultiDecorator([new CompositeDecorator(decorators)]);
};

export default createMultipleDecorator;
